import React from 'react';

function ExportPonukaPdfModal({
  jeOtvoreny,
  nazovSuboruPdf,
  setNazovSuboruPdf,
  menoKlientaPdf,
  setMenoKlientaPdf,
  pdfSekcie,
  setPdfSekcie,
  onZavriet,
  onPotvrdit,
}) {
  if (!jeOtvoreny) return null;

  const prepniSekciu = (kluc) => {
    setPdfSekcie((prev) => ({
      ...prev,
      [kluc]: !prev[kluc],
    }));
  };

  const pdfSekcieBezGrafu = [
    { kluc: 'zahrnutPredcasneSplatenie', label: 'Predčasné splatenie' },
    { kluc: 'zahrnutInvestovanie', label: 'Sporenie / investovanie' },
    { kluc: 'zahrnutSplatkovyKalendar', label: 'Splátkový kalendár' },
    { kluc: 'zahrnutPorovnavac', label: 'Porovnávač bánk' },
    { kluc: 'zahrnutPoznamku', label: 'Poznámka' },
  ];

  return (
    <div className="pdf-modal-overlay" onClick={onZavriet}>
      <div
        className="pdf-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pdf-modal__header">
          <h2 className="pdf-modal__title">Uložiť ponuku do PDF</h2>
        </div>

        <div className="pdf-modal__body">
          <div className="pdf-modal__grid">
            <div className="pdf-modal__field">
              <label className="pdf-modal__label" htmlFor="pdf-nazov-suboru">
                Názov súboru
              </label>
              <input
                id="pdf-nazov-suboru"
                className="pdf-modal__input"
                type="text"
                value={nazovSuboruPdf}
                onChange={(e) => setNazovSuboruPdf(e.target.value)}
                placeholder="Ponuka_hypoteka"
              />
            </div>

            <div className="pdf-modal__field">
              <label className="pdf-modal__label" htmlFor="pdf-meno-klienta">
                Meno klienta
              </label>
              <input
                id="pdf-meno-klienta"
                className="pdf-modal__input"
                type="text"
                value={menoKlientaPdf}
                onChange={(e) => setMenoKlientaPdf(e.target.value)}
                placeholder="Meno klienta"
              />
            </div>
          </div>

          <div className="pdf-modal__sekcie">
            <div className="pdf-modal__sekcie-title">Sekcie v PDF</div>

            <div className="pdf-modal__checkbox-grid">
              {pdfSekcieBezGrafu.map((sekcia) => (
                <label className="pdf-modal__checkbox" key={sekcia.kluc}>
                  <input
                    type="checkbox"
                    checked={Boolean(pdfSekcie?.[sekcia.kluc])}
                    onChange={() => prepniSekciu(sekcia.kluc)}
                  />
                  <span>{sekcia.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="pdf-modal__footer">
          <button
            type="button"
            className="pdf-modal__btn pdf-modal__btn--secondary"
            onClick={onZavriet}
          >
            Zavrieť
          </button>

          <button
            type="button"
            className="pdf-modal__btn pdf-modal__btn--primary"
            onClick={onPotvrdit}
          >
            Vygenerovať PDF
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExportPonukaPdfModal;